var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteAudioTourIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "white-audio-tour-icon_svg__a",
    d: "M0 0h9.186v14.794H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.405 9.997a.737.737 0 010-1.043 2.206 2.206 0 000-3.113.739.739 0 011.043-1.044 3.68 3.68 0 010 5.2.737.737 0 01-1.043 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 11.893a.739.739 0 010-1.044 4.887 4.887 0 000-6.904.739.739 0 011.043-1.044 6.366 6.366 0 010 8.992.738.738 0 01-1.043 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "white-audio-tour-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-audio-tour-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#white-audio-tour-icon_svg__b)",
    d: "M3.817 3.818H0v7.277h3.817v-.119l5.369 3.818V0z"
  })))));
}

export default SvgWhiteAudioTourIcon;